import Vue from 'vue'
import _ from 'lodash'
import { GET__ACADEMY_COURSES_BY_TYPE } from '~/graphql/queries/academyCourses'
import { COURSE_LIMIT } from '~/utils/const.js'

const actionTypes = {
  FETCH_ACADEMY_COURSES: 'FETCH_ACADEMY_COURSES',
  FETCH_INTERNAL_COURSES: 'FETCH_INTERNAL_COURSES',
  SEARCH_ACADEMY_COURSES: 'SEARCH_ACADEMY_COURSES',
}

const mutationTypes = {
  SET_LIST_COURSES: 'SET_LIST_COURSES',
  SET_FETCHING: 'SET_FETCHING',
  SET_FETCHING_ERROR: 'SET_FETCHING_ERROR',
  SET_HOME_VIEW: 'SET_HOME_VIEW',
  SET_FILTER_COURSE: 'SET_FILTER_COURSE',
  SET_FIELD_FILTER_COURSE: 'SET_FIELD_FILTER_COURSE',
  SET_LIST_ALL_COURSES: 'SET_LIST_ALL_COURSES',
  SET_COURSE_DETAIL: 'SET_COURSE_DETAIL',
}

export const state = () => ({
  externalCourses: [],
  academyCourses: [],
  internalCourses: [],
  error: false,
  fetching: false,
  filterCourses: {
    search: '',
    tags: [],
    page: 1,
  },
  homeView: 'USER',
  listAllCourses: [],
})

export const mutations = {
  [mutationTypes.SET_FETCHING](state, fetching) {
    state.fetching = fetching
  },
  [mutationTypes.SET_LIST_COURSES](state, { newData, isRenew, type }) {
    if (isRenew) {
      state[type || 'academyCourses'] = newData
      return
    }

    newData.forEach((newCourse) => {
      const index = _.findIndex(state[type || 'academyCourses'], { id: newCourse.id })
      if (index > -1) {
        Object.assign(state[type || 'academyCourses'][index], newCourse)
      } else {
        state[type || 'academyCourses'].push(newCourse)
      }
    })
    state.fetching = false
    state.error = false
  },
  [mutationTypes.SET_FETCHING_ERROR](state, error) {
    state.fetching = false
    state.error = error
  },
  [mutationTypes.SET_HOME_VIEW](state, value) {
    state.homeView = value
  },
  [mutationTypes.SET_FILTER_COURSE](state, value) {
    state.filterCourses = value
  },
  [mutationTypes.SET_FIELD_FILTER_COURSE](state, params) {
    state.filterCourses[params.key] = params.value
  },
  [mutationTypes.SET_LIST_ALL_COURSES](state, value) {
    state.listAllCourses = value
  },
  [mutationTypes.SET_COURSE_DETAIL](state, course) {
    if (course.isAcademy !== undefined) {
      const foundIndex = state[course.isAcademy ? 'academyCourses' : 'internalCourses'].findIndex(
        (item) => item.id === course.id
      )
      if (foundIndex !== -1) {
        Vue.set(
          state[course.isAcademy ? 'academyCourses' : 'internalCourses'],
          foundIndex,
          _.omit(course, ['isAcademy'])
        )
      }
    }
  },
}

export const actions = {
  async [actionTypes.FETCH_ACADEMY_COURSES](
    { commit, state, rootState },
    params = { needStored: true, page: 1, type: '', isRenew: false, limit: COURSE_LIMIT }
  ) {
    const {
      page,
      needStored,
      type,
      isRenew,
      status,
      limit,
      onlyShowEnrolledVersion,
      sharedCourseEnrollable,
      includeSharedCourseMode,
      isLatest,
    } = params
    if (needStored) {
      commit(mutationTypes.SET_FETCHING, true)
    }
    const schoolId = rootState.school.schoolProfile.id
    const { search, tags } = state.filterCourses
    const defaultParams = {
      tags,
      limit,
      search,
      type: 'LITTLE_ACADEMY',
      page,
      status,
      schoolId,
      isLatest,
      onlyShowEnrolledVersion,
      sharedCourseEnrollable,
      includeSharedCourseMode,
    }
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      if (type) {
        defaultParams.type = type
      }
      const response = await apolloClient.query({
        query: GET__ACADEMY_COURSES_BY_TYPE,
        fetchPolicy: 'no-cache',
        variables: defaultParams,
      })
      const academyCourses = response.data.academyCourses.data
      const commitCourseType = type === 'INTERNAL' ? 'internalCourses' : 'academyCourses'

      commit(mutationTypes.SET_LIST_COURSES, { newData: academyCourses, isRenew, type: commitCourseType })

      return { total: response.data.academyCourses.meta.total, success: true }
    } catch (error) {
      commit(mutationTypes.SET_FETCHING_ERROR, error)
      return { error, success: false }
    }
  },
}

export const getters = {
  externalCourses: (state) => state.externalCourses,
  academyCourses: (state) => state.academyCourses,
  internalCourses: (state) => state.internalCourses,
  error: (state) => state.error,
  fetching: (state) => state.fetching,
  filterCourses: (state) => state.filterCourses,
  listAllCourses: (state) => state.listAllCourses,
  courseType: () => ({
    LITTLE_ACADEMY: 'LITTLE_ACADEMY',
    INTERNAL: 'INTERNAL',
    EXTERNAL: 'EXTERNAL',
  }),
}
